import React from "react";

import {
  FaCalculator,
  FaRedo,
  FaVenusMars,
} from "react-icons/fa";

import {
  GENDER_OPTIONS,
} from "../data/judoCategoryRules";

import CateButton from "../ui/CateButton";

import FormField, {
  fieldClassName,
} from "../ui/FormField";

export default function CategoryCalculator({
  season,
  seasonOptions,
  formData,
  onSeasonChange,
  onFieldChange,
  onCalculate,
  onReset,
}) {
  const handleSubmit = (event) => {
    event.preventDefault();
    onCalculate();
  };

  return (
    <section className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-[0_24px_70px_rgba(15,23,42,0.10)] dark:border-white/10 dark:bg-slate-900">
      <header className="border-b border-slate-200 bg-gradient-to-br from-slate-950 via-slate-900 to-orange-950 p-6 text-white dark:border-white/10 sm:p-7">
        <div className="flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-amber-400 text-xl text-slate-950">
            <FaCalculator />
          </span>

          <div>
            <p className="text-xs font-black uppercase tracking-[0.18em] text-amber-300">
              Calculateur
            </p>

            <h2 className="mt-1 text-2xl font-black">
              Trouvez votre catégorie
            </h2>

            <p className="mt-2 text-sm leading-6 text-slate-300">
              La date de naissance détermine
              la catégorie d’âge. Le poids est
              facultatif.
            </p>
          </div>
        </div>
      </header>

      <form
        onSubmit={handleSubmit}
        className="space-y-6 p-5 sm:p-7"
      >
        <FormField
          label="Saison sportive"
          required
        >
          <select
            value={season}
            onChange={(event) =>
              onSeasonChange(
                event.target.value
              )
            }
            className={fieldClassName}
          >
            {seasonOptions.map(
              (seasonOption) => (
                <option
                  key={seasonOption}
                  value={seasonOption}
                >
                  Saison {seasonOption}
                </option>
              )
            )}
          </select>
        </FormField>

        <div>
          <p className="mb-2 text-sm font-black text-slate-700 dark:text-slate-200">
            Genre de compétition
          </p>

          <div className="grid grid-cols-2 rounded-2xl bg-slate-100 p-1 dark:bg-white/5">
            {GENDER_OPTIONS.map(
              (option) => {
                const isActive =
                  formData.gender ===
                  option.value;

                return (
                  <button
                    key={option.value}
                    type="button"
                    onClick={() =>
                      onFieldChange(
                        "gender",
                        option.value
                      )
                    }
                    className={[
                      "flex min-h-12 items-center justify-center gap-2 rounded-xl px-4 text-sm font-black transition",
                      isActive
                        ? "bg-white text-slate-950 shadow-md dark:bg-slate-700 dark:text-white"
                        : "text-slate-500 hover:text-slate-950 dark:text-slate-400 dark:hover:text-white",
                    ].join(" ")}
                  >
                    <FaVenusMars />
                    {option.label}
                  </button>
                );
              }
            )}
          </div>
        </div>

        <div className="grid gap-5 sm:grid-cols-2">
          <FormField
            label="Date de naissance"
            required
          >
            <input
              type="date"
              value={formData.birthDate}
              onChange={(event) =>
                onFieldChange(
                  "birthDate",
                  event.target.value
                )
              }
              max={new Date()
                .toISOString()
                .slice(0, 10)}
              className={fieldClassName}
            />
          </FormField>

          <FormField
            label="Poids"
            hint="Facultatif"
          >
            <div className="relative">
              <input
                type="number"
                min="10"
                max="300"
                step="0.1"
                inputMode="decimal"
                value={formData.weight}
                onChange={(event) =>
                  onFieldChange(
                    "weight",
                    event.target.value
                  )
                }
                placeholder="Ex. 67,5"
                className={`${fieldClassName} pr-12`}
              />

              <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-sm font-black text-slate-400">
                kg
              </span>
            </div>
          </FormField>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row">
          <CateButton
            type="submit"
            icon={FaCalculator}
            className="flex-1"
          >
            Calculer mes catégories
          </CateButton>

          <CateButton
            icon={FaRedo}
            variant="secondary"
            onClick={onReset}
          >
            Réinitialiser
          </CateButton>
        </div>
      </form>
    </section>
  );
}